export default function headerTemplate() {
	const nav = document.querySelector(".main-nav");
	if (!nav) return;

	const topItems = nav.querySelectorAll(":scope > ul > li.menu-item-has-children");

	const closeAllTop = () => {
		topItems.forEach((i) => i.setAttribute("aria-expanded", "false"));
	};

	const resetStage = (wrapper) => {
		const stage = wrapper.querySelector(".submenu-stage");
		if (!stage) return;
		stage.querySelectorAll(".stage-col").forEach((c) => c.remove());
	};

	const hideOriginalSubmenus = (wrapper) => {
		wrapper.querySelectorAll(".secondary ul ul").forEach((ul) => {
			ul.style.display = "none";
		});
	};

	const clearInjectedParentLink = (wrapper) => {
		wrapper.querySelectorAll(".secondary > ul > li.submenu-parent-link").forEach((li) => li.remove());
	};

	const prependParentLink = (wrapper, parentLink) => {
		const list = wrapper.querySelector(".secondary > ul");
		if (!list || !parentLink) return;

		clearInjectedParentLink(wrapper);

		const label = (parentLink.textContent || "").trim();
		const href = parentLink.getAttribute("href");
		if (!label || !href) return;

		const parentLi = document.createElement("li");
		parentLi.className = "submenu-parent-link";

		const a = document.createElement("a");
		a.textContent = label;
		a.href = href;

		const target = parentLink.getAttribute("target");
		if (target) a.setAttribute("target", target);

		const rel = parentLink.getAttribute("rel");
		if (rel) a.setAttribute("rel", rel);

		parentLi.appendChild(a);
		list.insertBefore(parentLi, list.firstChild);
	};

	const closeSiblings = (li) => {
		const parentUl = li.parentElement;
		if (!parentUl) return;
		parentUl.querySelectorAll(":scope > li.menu-item-has-children").forEach((sib) => {
			if (sib !== li) sib.setAttribute("aria-expanded", "false");
		});
	};

	const openColumn = (wrapper, li, depth) => {
		const stage = wrapper.querySelector(".submenu-stage");
		if (!stage) return;

		const submenu = li.querySelector(":scope > ul.sub-menu");
		if (!submenu) return;

		stage.querySelectorAll(".stage-col").forEach((col) => {
			const colDepth = parseInt(col.dataset.depth, 10);
			if (colDepth >= depth) col.remove();
		});

		const col = document.createElement("div");
		col.className = "stage-col";
		col.dataset.depth = String(depth);
		col.appendChild(submenu.cloneNode(true));
		stage.insertBefore(col, getCard(wrapper) || null);
	};

	const getWrapper = (el) => el.closest(".wrapper-submenu");

	const getActiveSecondaryLi = (wrapper) =>
		wrapper.querySelector(".secondary > ul > li[aria-expanded='true']");

	const getCard = (wrapper) => wrapper.querySelector(".submenu-stage > .submenu-card");

	const getMaxStageDepth = (wrapper) => {
		const stage = wrapper.querySelector(".submenu-stage");
		if (!stage) return -1;
		const cols = Array.from(stage.querySelectorAll(".stage-col"));
		if (!cols.length) return -1;
		return Math.max(...cols.map((c) => parseInt(c.dataset.depth, 10)));
	};

	const isTrainingEventsActive = (wrapper) => {
		const li = getActiveSecondaryLi(wrapper);
		if (!li) return false;

		if (li.classList.contains("has-submenu-card")) return true;

		const a = li.querySelector(":scope > a");
		const txt = (a?.textContent || "").trim().toLowerCase();
		return txt === "training and events";
	};

	const setDividerState = (wrapper, cardVisible) => {
		const stage = wrapper.querySelector(".submenu-stage");
		if (!stage) return;

		stage.querySelectorAll(".stage-col.no-divider").forEach((c) => c.classList.remove("no-divider"));

		if (!cardVisible) return;

		const cols = Array.from(stage.querySelectorAll(".stage-col"));
		const last = cols[cols.length - 1];
		if (last) last.classList.add("no-divider");
	};

	const updateCard = (wrapper) => {
		const card = getCard(wrapper);
		if (!card) return;

		const activeOk = isTrainingEventsActive(wrapper);
		const maxDepth = getMaxStageDepth(wrapper);

		const show = activeOk && maxDepth <= 0;

		card.classList.toggle("is-active", show);

		setDividerState(wrapper, show);
	};


	const resetWrapperAria = (wrapper) => {
		resetStage(wrapper);
		clearInjectedParentLink(wrapper);
		wrapper.querySelectorAll('li.menu-item-has-children[aria-expanded="true"]').forEach((li) => {
			li.setAttribute("aria-expanded", "false");
		});
		updateCard(wrapper);
	};

	const getActiveSecondaryLink = (wrapper) => {
		const activeLi = wrapper.querySelector(".secondary li.menu-item-has-children[aria-expanded='true']");
		return activeLi ? activeLi.querySelector(":scope > a") : null;
	};

	const getSecondaryLinks = (wrapper) =>
		Array.from(wrapper.querySelectorAll(".secondary > ul > li > a")).filter((a) => a.offsetParent !== null);

	const getStageLinksByDepth = (wrapper, depth) => {
		const stage = wrapper.querySelector(".submenu-stage");
		if (!stage) return [];
		const col = stage.querySelector(`.stage-col[data-depth="${depth}"]`);
		if (!col) return [];
		return Array.from(col.querySelectorAll("a")).filter((a) => a.offsetParent !== null);
	};

	const getStageFirstLinkByDepth = (wrapper, depth) => {
		const links = getStageLinksByDepth(wrapper, depth);
		return links[0] || null;
	};

	const getLinkIndex = (arr, el) => arr.indexOf(el);

	const getNextLinkInSameLevel = (currentA, levelLinks) => {
		const idx = getLinkIndex(levelLinks, currentA);
		if (idx === -1) return null;
		return levelLinks[idx + 1] || null;
	};

	const getCurrentLevelInfo = (wrapper, target) => {
		const inSecondary = !!target.closest(".secondary");
		if (inSecondary) return { type: "secondary", depth: -1 };

		const col = target.closest(".stage-col");
		if (col) return { type: "stage", depth: parseInt(col.dataset.depth, 10) };

		return null;
	};

	const getLevelLinks = (wrapper, info) => {
		if (!info) return [];
		if (info.type === "secondary") return getSecondaryLinks(wrapper);
		return getStageLinksByDepth(wrapper, info.depth);
	};

	const getFirstLinkOfNextLevel = (wrapper, info) => {
		if (!info) return null;
		if (info.type === "secondary") return getStageFirstLinkByDepth(wrapper, 0);
		return getStageFirstLinkByDepth(wrapper, info.depth + 1);
	};

	const getActiveLinkOfPrevLevel = (wrapper, info) => {
		if (!info) return null;

		if (info.type === "stage" && info.depth === 0) return getActiveSecondaryLink(wrapper);

		if (info.type === "stage" && info.depth > 0) {
			const prevDepth = info.depth - 1;
			const stage = wrapper.querySelector(".submenu-stage");
			const prevCol = stage ? stage.querySelector(`.stage-col[data-depth="${prevDepth}"]`) : null;
			if (!prevCol) return null;
			const activeLi = prevCol.querySelector(`li.menu-item-has-children[aria-expanded="true"]`);
			return activeLi ? activeLi.querySelector(":scope > a") : null;
		}

		return null;
	};

	const hasSubmenu = (a) => {
		const li = a?.closest("li.menu-item-has-children");
		if (!li) return false;
		return !!li.querySelector(":scope > ul.sub-menu");
	};

	const focusNextPrimaryFromWrapper = (wrapper) => {
		const topLi = wrapper.closest("li.menu-item-has-children");
		if (!topLi) return;

		const parentUl = topLi.parentElement;
		if (!parentUl) return;

		const siblings = Array.from(parentUl.children);
		const idx = siblings.indexOf(topLi);

		for (let i = idx + 1; i < siblings.length; i++) {
			const nextA = siblings[i]?.querySelector(":scope > a");
			if (nextA && nextA.offsetParent !== null) {
				closeAllTop();
				topItems.forEach((it) => {
					const w = it.querySelector(":scope > .wrapper-submenu");
					if (w) resetWrapperAria(w);
				});
				nextA.focus();
				return;
			}
		}

		closeAllTop();
	};

	topItems.forEach((item) => {
		const link = item.querySelector(":scope > a");
		const wrapper = item.querySelector(":scope > .wrapper-submenu");
		if (!link || !wrapper) return;

		item.setAttribute("aria-expanded", "false");
		link.setAttribute("aria-haspopup", "true");

		hideOriginalSubmenus(wrapper);

		link.addEventListener("click", (e) => {
			e.preventDefault();

			const open = item.getAttribute("aria-expanded") === "true";
			closeAllTop();

			topItems.forEach((it) => {
				const w = it.querySelector(":scope > .wrapper-submenu");
				if (w) resetWrapperAria(w);
			});

			if (open) return;

			item.setAttribute("aria-expanded", "true");
			prependParentLink(wrapper, link);
			updateCard(wrapper);
		});
	});

	nav.addEventListener("click", (e) => {
		const a = e.target.closest(".wrapper-submenu a");
		if (!a) return;

		const li = a.closest("li.menu-item-has-children");
		if (!li) return;

		const wrapper = a.closest(".wrapper-submenu");
		if (!wrapper) return;

		const hasSub = !!li.querySelector(":scope > ul.sub-menu");
		if (!hasSub) {
			updateCard(wrapper);
			return;
		}

		e.preventDefault();

		closeSiblings(li);
		li.setAttribute("aria-expanded", "true");

		let depth = 0;
		const parentCol = a.closest(".stage-col");
		if (parentCol) depth = parseInt(parentCol.dataset.depth, 10) + 1;

		openColumn(wrapper, li, depth);
		updateCard(wrapper);
	});

	nav.addEventListener("keydown", (e) => {
		if (e.key !== "Tab") return;

		const wrapper = getWrapper(e.target);
		if (!wrapper) return;

		const info = getCurrentLevelInfo(wrapper, e.target);
		if (!info) return;

		const levelLinks = getLevelLinks(wrapper, info);
		if (!levelLinks.length) return;

		const isLast = levelLinks[levelLinks.length - 1] === e.target;
		const isFirst = levelLinks[0] === e.target;

		if (!e.shiftKey) {
			if (info.type === "secondary") {
				const currentLi = e.target.closest("li");
				const currentExpanded = currentLi?.getAttribute("aria-expanded") === "true";

				if (hasSubmenu(e.target) && currentExpanded) {
					const nextLevelFirst = getFirstLinkOfNextLevel(wrapper, info);
					if (nextLevelFirst) {
						e.preventDefault();
						nextLevelFirst.focus();
						return;
					}
				}

				if (isLast) {
					const lastHasSub = hasSubmenu(e.target);

					if (!lastHasSub) {
						e.preventDefault();
						focusNextPrimaryFromWrapper(wrapper);
						return;
					}

					const stageFirst = getStageFirstLinkByDepth(wrapper, 0);
					if (!stageFirst) {
						e.preventDefault();
						focusNextPrimaryFromWrapper(wrapper);
						return;
					}
				}

				return;
			}

			if (info.type === "stage") {
				if (hasSubmenu(e.target) && e.target.closest("li")?.getAttribute("aria-expanded") === "true") {
					const nextLevelFirst = getFirstLinkOfNextLevel(wrapper, info);
					if (nextLevelFirst) {
						e.preventDefault();
						nextLevelFirst.focus();
						return;
					}
				}

				if (isLast) {
					const prevActive = getActiveLinkOfPrevLevel(wrapper, info);
					const maxDepth = getMaxStageDepth(wrapper);

					if (prevActive) {
						const prevInfo =
							info.depth === 0 ? { type: "secondary", depth: -1 } : { type: "stage", depth: info.depth - 1 };

						const prevLinks = getLevelLinks(wrapper, prevInfo);
						const nextInPrev = getNextLinkInSameLevel(prevActive, prevLinks);

						if (nextInPrev) {
							e.preventDefault();
							nextInPrev.focus();
							return;
						}
					}

					if (info.depth === maxDepth) {
						e.preventDefault();
						focusNextPrimaryFromWrapper(wrapper);
						return;
					}
				}
			}

			return;
		}

		if (info.type === "stage") {
			if (isFirst) {
				const prevActive = getActiveLinkOfPrevLevel(wrapper, info);
				if (!prevActive) return;
				e.preventDefault();
				prevActive.focus();
			}
		}
	});

	document.addEventListener("click", (e) => {
		if (!e.target.closest(".main-nav")) {
			closeAllTop();
			topItems.forEach((i) => {
				const wrapper = i.querySelector(":scope > .wrapper-submenu");
				if (wrapper) resetWrapperAria(wrapper);
			});
		}
	});

	document.addEventListener("keydown", (e) => {
		if (e.key === "Escape") {
			closeAllTop();
			topItems.forEach((i) => {
				const wrapper = i.querySelector(":scope > .wrapper-submenu");
				if (wrapper) resetWrapperAria(wrapper);
			});
		}
	});
}
